module.exports = __webpack_public_path__ + "static/media/samples_per_room_type.7a59aa77.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/samples_per_room_type.csv
// module id = 697
// module chunks = 0